export default "__VITE_ASSET__BbO$h6ef__"